import { Chip } from '@reveni-io/reveni-ui'

import { getChipsData } from './helpers'
import * as Styles from './styles'

const FilterChips = ({ filters, onClickChip, onDeleteChip, context, isFilterValid }) => {
  const chipsData = getChipsData(filters, context, isFilterValid)

  if (!chipsData.length) return null

  return (
    <Styles.Container>
      {chipsData.map(({ filter, Icon, label }) => (
        <Chip
          key={filter.id}
          Icon={Icon}
          label={label}
          onClick={() => onClickChip(filter.id)}
          onDelete={() => onDeleteChip(filter.id)}
        />
      ))}
    </Styles.Container>
  )
}

export default FilterChips
